module.exports = __webpack_public_path__ + "static/img/13.cec1ecb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/sp/13.png
// module id = aR1D
// module chunks = 0